import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="side1">
            <div className="row">
              <div className="col-md-3">
                <h1 className="logo">Seionic Technologies</h1>
                <p className="footer-text">
                  All rights reserved 2024
                </p>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Important Links</p>
                <ul>
                  <li>
                    <Link to="/" aria-label="Go to Home">Home</Link>
                  </li>
                  <li>
                    <Link to="/About" aria-label="Go to About Us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/Embedded-Systems" aria-label="Go to Embedded Systems Page">Embedded Systems</Link>
                  </li>
                  <li>
                    <Link to="/Intelligent-Transport" aria-label="Go ITMS Page">Intelligent Transport Systems</Link>
                  </li>
                  <li>
                    <Link to="/Software-Development" aria-label="Go Software Page">Software Development</Link>
                  </li>

                  <li>
                    <Link to="/Display-Panel" aria-label="Go Software Page">Display Panel</Link>
                  </li>

                  <li>
                    <Link to="/Manufacturing-Partner" aria-label="Go Software Page">Partners</Link>
                  </li>

                  <li>
                    <Link to="/Clients" aria-label="Go to About Us">Clients</Link>
                  </li>
                  <li>
                    <Link to="/Careers" aria-label="Go to Contact">Careers</Link>
                  </li>
                  <li>
                    <Link to="/Contact" aria-label="Go to Contact">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="side2">
            <div className="row">
              <div className="col-md-3">
                <p className="footer-title">Contact</p>
                <ul>
                  <li>
                    <a href="mailto:contact@seionic.com">contact@seionic.com</a>
                  </li>
                  <li>
                    <a href="https://www.google.com/maps/place/Seionic+Technologies+Private+Limited/@12.9105962,80.222223,17z/data=!4m6!3m5!1s0x3a525bbba58bbc17:0x6a375a2f7e7eee57!8m2!3d12.910596!4d80.226729!16s%2Fg%2F11lw7klvxm?entry=ttu&g_ep=EgoyMDI0MTIwMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" >
                      M142-Cactus, B-Block , 4th Floor, Tecci Park, OMR, Sholinganallur, Chennai 600 119
                    </a>
                  </li>
                  <li>
                    <a href="tel:+917299937663" >+91 7299937663</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Social Media</p>
                <ul>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.linkedin.com/company/seionic-technologies/"
                    >
                      LinkedIn
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        onClick={() => window.scrollTo(0, 0)} // Scroll to top when clicked
        className="gotop"
        aria-label="Scroll to Top"
      >
        <i className="fas fa-level-up-alt"></i>
      </button>
    </footer>
  );
}

export default Footer;
